module.exports = __webpack_public_path__ + "static/media/xendit-blue-logo.22da7130.svg";